export enum ITVErrorCode {
    PERSIST_FAILED = 'PERSIST_FAILED',
    COMPARISON_FAILED = 'COMPARISON_FAILED',
}

export class ITVError extends Error {
    public readonly errorCode: ITVErrorCode;

    constructor(message: string, errorCode: ITVErrorCode) {
        super(message);
        this.name = this.constructor.name;
        Object.setPrototypeOf(this, new.target.prototype);
        this.errorCode = errorCode;
    }

    public toString(): string {
        return `ITVError: [${this.errorCode}] ${this.message}`;
    }
}
